async function getUserProfile(apiUrl: string) {
  const token = localStorage.getItem('whitelabel/token');
  const parsedToken = token ? JSON.parse(token) : '';

  const response = await fetch(`${apiUrl}/user/profile`, {
    headers: {
      Authorization: `Bearer ${parsedToken}`
    }
  });

  if (!response.ok) {
    throw new Error("Can't get user profile");
  }

  return await response.json();
}

export function updateFavicon(customizationUrlBE: string, apiUrl: string) {
  const defaultFaviconUrl = `${customizationUrlBE}/favicon.ico`;

  let link = document.querySelector<HTMLLinkElement>("link[rel*='icon']");

  if (!link) {
    link = document.createElement('link');
    link.setAttribute('rel', 'icon');
    document.head.appendChild(link);
  }

  //link.setAttribute('href', `${defaultFaviconUrl}`);
  // in the moment of initialization we can dont have a token
  // that's why we are checking storage changing
  setTimeout(async () => {
    try {
      const userProfile = await getUserProfile(apiUrl);
      const isEnabled = userProfile?.brandingEnabled;
      const brandingFaviconUrl = userProfile?.faviconUrl;

      if (isEnabled && brandingFaviconUrl) {
        const response = await fetch(brandingFaviconUrl);

        if (response.ok) {
          link?.setAttribute('href', brandingFaviconUrl);
        } else {
          link?.setAttribute('href', defaultFaviconUrl);
          console.error("Can't download branch favicon");
        }
      } else {
        link?.setAttribute('href', defaultFaviconUrl);
      }
    } catch (err) {
      link?.setAttribute('href', defaultFaviconUrl);
      console.error('Error while updating favicon favicon:', err);
    }
  }, 2000);
}
